(function() {
    'use strict';

    angular.module('app.procesarPlanilla', []);
})();
